import {Component, OnInit, NgZone, OnDestroy} from '@angular/core';
import {UserProfileService} from '../../services/user/user-profile.service';
import {Subscription} from "rxjs";
import {InternationalizationService} from "../../services/internationalization/internationalization.service";
import {$translate} from "../../services/internationalization/localize.service";
import { ItemModel, MenuEventArgs } from '@syncfusion/ej2-angular-splitbuttons';

@Component({
  selector: 'sb-developer-menu-bar',
  templateUrl: './developer-menu-bar.component.html',
  styleUrls: ['./developer-menu-bar.component.scss']
})
export class DeveloperMenuBarComponent implements OnInit, OnDestroy {

  constructor(private userProfileService: UserProfileService,
              private i18nService: InternationalizationService,
              private ngZone: NgZone) { }

  public currentState: string = null;
  public currentApplication: any = {};
  public currentChangeSetID: string = null;
  public currentChangeSetName = "Not selected";
  public changeSets: any[] = [];

  buttonLabel = '...';
  showCurrentLabel;
  allChangeSetsLabel;
  trackingOffLabel;
  trackingConfigurationLabel;
  trackingAllLabel;
  private localeChanged$: Subscription;

  private MessageBus = (window as any).MessageBus;

  public trackingDropdownItems: ItemModel[];
  public changesetDropdownItems: ItemModel[];

  ngOnInit(): void {
    this.MessageBus.subscribe(this.MessageBus.CHANNELS.MESSAGE_BUS_BRIDGE_API, UserProfileService.USERPROFILE_UPDATE_TOPIC, data => {
      this.ngZone.run(() => {
        this.updateValues(data);
      });
    });
    this.updateDetails();

    this.localeChanged$ = this.i18nService.localeChanged$.subscribe((locale: string) => {
      this.updateData();
    });

    this.updateData();
  }

  ngOnDestroy() {
    this.localeChanged$ && this.localeChanged$.unsubscribe();
  }

  private updateValues(data) {
    this.currentState = data["changeTracking"];
    this.currentApplication = data["userApplication"];
    this.currentChangeSetID = data["userChangeSet"];
    this.currentChangeSetName = data["userChangeSetName"];
    this.buttonLabel = `
      <span class="application-name">${this.currentApplication.name}</span>
      <span class="changeset-name">${this.currentChangeSetName}</span>
    `;
    this.getChangeSets();

    this.updateData();
  }

  private async updateDetails() {
    const profile = await this.userProfileService.getUserProfile(false);
    this.updateValues(profile);
  }

  public buttonClassList(additionalClasses: string, buttonName: string) {
    const stateClass = (buttonName === this.currentState) ? 'button-active' : 'button-inactive';
    return additionalClasses + " " + stateClass;
  }

  public transitionTo(trackingState: string) {
    this.userProfileService.updateUserProfileSetting("changeTracking", trackingState);
  }

  public updateChangeSet(changeSetID: string) {
    this.userProfileService.updateUserProfileSetting("userChangeSet", changeSetID);
  }

  public getChangeSets() {
    window["REST"].get("ChangeSet", null, { fields: "Name,id", "WorkflowStatus": "open"}).done(data => {
      this.ngZone.run(() => {
        // If the user is not allowed to read ChangeSet then data.data will be undefined.
        if (data.data) {
          this.changeSets = data.data;
        }
        this.updateData();
      });
    });
  }

  private updateData() {
    this.showCurrentLabel = $translate("ng.component.developer-menu-bar.show")`View this change set`;
    this.allChangeSetsLabel = $translate("ng.component.developer-menu-bar.all")`View all change sets`;
    this.trackingOffLabel = $translate("ng.component.developer-menu-bar.tracking-off")`Tracking off`;
    this.trackingConfigurationLabel = $translate("ng.component.developer-menu-bar.tracking-configuration")`Tracking configuration`;
    this.trackingAllLabel = $translate("ng.component.developer-menu-bar.tracking-all")`Tracking all changes`;
    this.trackingDropdownItems = [
      { id: "OFF", text: this.trackingOffLabel },
      { id: "CONFIGURATION", text: this.trackingConfigurationLabel },
      { id: "ALL", text: this.trackingAllLabel },
    ];
    if (this.changeSets) {
      this.changesetDropdownItems = [
        ...this.changeSets.map(it => ({ id: it.id, text: it.Name })),
        { separator: true },
        { text: this.showCurrentLabel, url: `/#/ChangeSet/${this.currentChangeSetID}` },
        { text: this.allChangeSetsLabel, url: '/#/ChangeSet' },
      ];
    }
  }

  public selectTracking(args: MenuEventArgs) {
    this.transitionTo(args.item.id);
  }

  public selectChangeset(args: MenuEventArgs) {
    // this.transitionTo(args.item.id);
  }

}
